import app from 'flarum/app';
import Component from 'flarum/Component';
import Dropdown from 'flarum/components/Dropdown';
import Button from 'flarum/components/Button';

export default class FormSortDropdown extends Component {
    view() {
        const sortOptions = {};

        ['latest', 'oldest'].forEach(key => {
            sortOptions[key] = app.translator.trans('kilowhat-formulaire.forum.form-sort.' + key);
        });

        return Dropdown.component({
            buttonClassName: 'Button',
            label: sortOptions[this.props.sort] || Object.keys(sortOptions).map(key => sortOptions[key])[0],
        }, Object.keys(sortOptions).map(value => {
            const label = sortOptions[value];
            const active = (this.props.sort || Object.keys(sortOptions)[0]) === value;

            return Button.component({
                icon: active ? 'fas fa-check' : true,
                onclick: () => {
                    this.props.onchange(value);
                },
                active,
            }, label);
        }));
    }
}
